import React from 'react';

const OperationsIcon = () => {
  return (
    <svg version="1.1" 
    id="Layer_1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlnsXlink="http://www.w3.org/1999/xlink" 
    x="0px" y="0px"
    viewBox="0 0 14 14"
     style={{'enableBackground':'new 0 0 14 14', width:'20px'}}
      xmlSpace="preserve">
 <path d="M0,4.2h3V14H0V4.2z M5.6,0h2.8v14H5.6V0z M11.2,8H14v6h-2.8V8z"/>
 </svg>
 
  );
};

export default OperationsIcon;
